"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");














































































































var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));
var _user = require("@/utils/user");
var _aliOss = _interopRequireDefault(require("@/utils/aliOss2"));
var _index = require("@/utils/index"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], searchData: { deviceTypeId: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', urls: '', deviceTypeName: '', addData: { id: '', deviceTypeId: '', fileUrl: '', locale: '' }, defaultData: { id: '', deviceTypeId: '', fileUrl: '', locale: '' }, rules: { deviceTypeId: [{ required: true, message: '请选择所属型号', trigger: 'change' }], fileUrl: [{ required: true, message: '请上传文件', trigger: 'blur' }], locale: [{ required: true, message: '请选择说明书语言', trigger: ['blur', 'change'] }] }, languageList: [] };}, mounted: function mounted() {var self = this;self.init();self.getdrop();self.fetchLanguageList();}, methods: { checkPermission: _user.checkPermission, init: function init() {var self = this;self.getData('/api/faDeviceTypeInstructions', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * 获取语言列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         */fetchLanguageList: function fetchLanguageList() {var _this = this;this.getData('/api/language/list', {}, function (res) {_this.languageList = res;});}, resetFun: function resetFun() {// 重置
      this.searchData.deviceTypeId = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, delMenu: function delMenu(item) {var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(function () {self.delData('/api/faDeviceTypeInstructions/' + item.id, {}, function (res) {self.$message({ message: '删除成功!', type: 'success' });self.searchData.page = 1;self.init();});}).catch(function () {});}, addFun: function addFun() {// 新增
      this.title = '新增';this.newimg = '';this.addData = JSON.parse(JSON.stringify(this.defaultData));this.newadd = true;}, closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();done();
    },
    onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faDeviceTypeInstructions', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },

    updateMenu: function updateMenu(item) {
      this.title = '修改';
      var self = this;
      self.getData('/api/faDeviceTypeInstructions/' + item.id, self.searchData, function (res) {
        self.addData = {
          id: res.id,
          deviceTypeId: res.deviceTypeId,
          fileUrl: res.fileUrl,
          locale: res.locale };

        self.newadd = true;
      });
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faDeviceTypeInstructions/' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.searchData.page = 1;
            self.init();
            self.onCencal();
          });
        } else {
          return false;
        }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.droplist = res;
      });
    },
    fnUploadRequest: function fnUploadRequest(option) {
      var path = 'e-instructions';
      _aliOss.default.ossUploadFile(option, path);
    },
    beforUpload: function beforUpload(file) {
      var MAX_SIZE = 1024 * 1024 * 100;
      if (file.size > MAX_SIZE) {
        this.$message({
          type: 'error',
          message: '文件大小超过100M' });

        return false;
      }
      return true;
    },
    beforeRemove: function beforeRemove(file, fileList) {
      console.log(file);
      var fileName = file.name;
      var confirm = '确定移除' + fileName + '？';
      return this.$confirm(confirm);
    },
    handleOnRemove: function handleOnRemove(file, fileList) {
      this.addData.fileUrl = '';
      this.$message('移除' + file.name + '成功');
    },
    onsuccess: function onsuccess(res) {
      console.log('res:', res);
      var fileUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      this.addData.fileUrl = fileUrl;
      this.$refs.upload.clearValidate();
    },
    // 二维码
    lookView: function lookView(item) {// 查看弹窗
      this.title = '查看';
      $('#dialog2').show();
      console.log('item:', item);
      this.urls = item.fileUrl;
      this.deviceTypeName = item.deviceTypeName;
      this.qrcode();
    },
    qrcode: function qrcode(item) {
      item = this.urls;
      var text = '';
      if (item.indexOf('manual.cozzia.com.cn') >= 0) {
        text = "http://manual.cozzia.com.cn/index2.html?urls=".concat(item);
      } else {
        text = "https://cdn-tech.cozzia.com.cn/index2.html?url=".concat(item);
      }
      console.log('text======>', text);
      document.getElementById('qrcode').innerHTML = '';
      new _qrcodejs.default('qrcode', {
        width: 300,
        height: 300, // 高度
        text: text, // 二维码内容
        render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        correctLevel: 3 });

      //		      	downloadButton: true
    },
    onCencal2: function onCencal2() {
      this.urls = '';
      this.deviceTypeName = '';
      $('#dialog2').hide();
      // window.location.reload()
    },
    downloadQrcode: function downloadQrcode() {
      var qrcode = document.getElementById('qrcode');
      var img = qrcode.getElementsByTagName('img')[0];
      var link = document.createElement('a');
      var url = img.getAttribute('src');
      link.setAttribute('href', url);
      link.setAttribute('download', this.deviceTypeName + '.png');
      link.click();
      this.onCencal2();
    } } };exports.default = _default;